import {
  AutoComplete,
  FormCheckBox,
  FormInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../../services/mainApi.service";
import { IGeneric } from "../../../../../../../models/generics";
import { TFileIntegrationForm } from "../../fileIntegrationSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.4uBus.uBusAutomationRobot.";

const GENERICS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<IGeneric>(GENERICS_ROUTE);

export const CopyFilesFields = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TFileIntegrationForm>();

  const currentMakeCopyFilesEndOfProcess = useWatch({
    name: "makeCopyFilesEndOfProcess",
    control,
  });

  const makeCopyChangeHandler = useCallback(
    (e: any) => {
      if (!e.target.checked) {
        setValue("copyFilesPath", null);
        setValue("copyProcess", null);
        setValue("renameFileProcess", null);
      }
    },
    [setValue],
  );

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{ paddingBottom: currentMakeCopyFilesEndOfProcess ? 0 : 11 }}
      >
        <FormCheckBox
          name="makeCopyFilesEndOfProcess"
          label={`${t(translationPath + "make_copy_files_end_of_process")}`}
          onChangeCapture={makeCopyChangeHandler}
        />
      </Grid>

      {currentMakeCopyFilesEndOfProcess && (
        <>
          <Grid item xs={12} sm={6}>
            <FormInput
              name="copyFilesPath"
              label={t(translationPath + "copy_files_path")}
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AutoComplete
              params={{ identifier: "CopyProcess" }}
              getOptionLabel={(option) => {
                return option.name;
              }}
              size="small"
              label={t(translationPath + "copy_process")}
              name="copyProcess"
              request={genericService.list}
            />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ paddingBottom: 11 }}>
            <AutoComplete
              params={{ identifier: "RenameFileProcess" }}
              getOptionLabel={(option) => {
                return option.name;
              }}
              size="small"
              label={t(translationPath + "rename_file_process")}
              name="renameFileProcess"
              request={genericService.list}
            />
          </Grid>
        </>
      )}
    </>
  );
});
